import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss']
})
export class HistoryComponent implements OnInit {
  dataHistory:any[] = []
  @Input() name_employee!: any;
  @Input() name_benefit!:any;
  @Input() requestData: any;
  motivoAprobacion: string = '';

  

  constructor(
    private activatedRoute: ActivatedRoute,
  ) {}

  async ngOnInit() {
   this.dataHistory = this.activatedRoute.snapshot.data['resolver_request_history_id'];   
   
   // Si no se pasan los datos por Input, usar el resolver (para retrocompatibilidad)
   if (!this.requestData) {
     this.requestData = this.activatedRoute.snapshot.data['resolver_request_details_id'];
   }
   
   this.comentarioHistorial()
   this.extraerMotivoAprobacion()
   this.dataHistory.sort((a:any, b:any) => b.id - a.id);

  }


  comentarioHistorial(){
    for(let item of this.dataHistory){
      item.comentario = JSON.parse(item.comentario)
    }      
  }

  extraerMotivoAprobacion(){
    if (this.requestData && this.requestData.requestdata) {
      try {
        const parsedData = JSON.parse(this.requestData.requestdata);
        this.motivoAprobacion = parsedData.motivo_aprobacion || '';
      } catch (error) {
        console.error('Error parsing requestdata:', error);
        this.motivoAprobacion = '';
      }
    }
  }

  textReplace(text:string){
    if(text.includes('[nombre_empleado]')){
       return text.replace('[nombre_empleado]', this.name_employee)
    }
    if(text.includes('[nombre_beneficio]')){
      return text.replace('[nombre_beneficio]', this.name_benefit)
    }
    return text
  }

  isObjectEmpty(obj: any): boolean {
    return Object.keys(obj).length === 0;
  }

}
